const en = {
    homeCarrying: 'Home-currency carrying value',
    nameAscending: 'Name: A–Z',
    nameDescending: 'Name: Z–A',
    bankReconciliation: 'Bank statements and ledger balances',
    sourceBalance: 'Statement balance',
    statementDate: 'Statement date',
    MATCHED: 'Reconciled',
    DIFFERENCE: 'Difference requires review',
    MISSING_STATEMENT: 'No statement balance available',
    MISSING_MAPPING: 'Select a matching ledger bank account',
    CURRENCY_MISMATCH: 'Account and statement currencies disagree',
    INCOMPLETE_CURRENCY: 'Missing original-currency ledger evidence',
    CONFLICTING_STATEMENTS: 'Conflicting balances on the same day',
    BEFORE_START: 'Statement predates the accounting start',
    UNMATCHED_BANK: 'Unresolved bank transactions',
    invalidDates: 'Enter a complete, valid reporting and comparison period.',
    title: 'Financial analysis and reconciliation',
    comparisonFrom: 'Comparison from',
    comparisonTo: 'Comparison to',
    forecastTo: 'Forecast through',
    refresh: 'Update report',
    aging: 'Aged open items',
    partners: 'Customer and supplier balances',
    cash: 'Actual cash flows',
    dimensions: 'Cost centers and cost objects',
    reconciliation: 'General ledger and subledger reconciliation',
    liquidity: 'Liquidity forecast',
    tasks: 'Tasks',
    definition: 'Posted revenue and expenses differ from actual money movements. Open items use dated events as of the selected day, including partner credits. The forecast uses remaining invoices at their due dates and currently planned payment dates (including for a historical reporting day), valued at documented carrying amounts. It assumes collection or payment; no bank transfer is submitted.',
    comparison: 'Comparison period',
    current: 'Not overdue',
    days1to30: '1–30 days overdue',
    days31to60: '31–60 days overdue',
    days61to90: '61–90 days overdue',
    over90: 'Over 90 days overdue',
    credits: 'Partner credits',
    inflow: 'Inflow',
    outflow: 'Outflow',
    opening: 'Opening balance',
    closing: 'Closing balance',
    ledgerAmount: 'General ledger',
    subledgerAmount: 'Open items',
    difference: 'Difference',
    receivables: 'Expected receipts',
    payables: 'Expected payments',
    balance: 'Projected cash balance',
    result: 'Result',
    empty: 'No matching financial data.',
    export: 'Export analysis',
    all: 'All',
    DRAFTS: 'Unposted journal drafts',
    OVERDUE_CUSTOMER: 'Overdue customer invoices',
    OVERDUE_VENDOR: 'Overdue supplier invoices',
    RECONCILIATION: 'Reconciliation differences',
    beforeStart: 'Choose a period on or after the accounting start date.',
};
export const ledgerAnalysisLabels = {
    en,
    de: {
        homeCarrying: 'Buchwert in Hauswährung',
        nameAscending: 'Bezeichnung: A–Z',
        nameDescending: 'Bezeichnung: Z–A',
        bankReconciliation: 'Kontoauszüge und Buchbestände',
        sourceBalance: 'Auszugssaldo',
        statementDate: 'Auszugsdatum',
        MATCHED: 'Abgestimmt',
        DIFFERENCE: 'Differenz prüfen',
        MISSING_STATEMENT: 'Kein Auszugssaldo vorhanden',
        MISSING_MAPPING: 'Passendes Bankkonto im Kontenplan zuordnen',
        CURRENCY_MISMATCH: 'Konto- und Auszugswährung widersprechen sich',
        INCOMPLETE_CURRENCY: 'Originalwährungsnachweis im Hauptbuch fehlt',
        CONFLICTING_STATEMENTS: 'Widersprüchliche Salden am selben Tag',
        BEFORE_START: 'Auszug liegt vor dem Buchhaltungsstart',
        UNMATCHED_BANK: 'Ungeklärte Bankumsätze',
        invalidDates: 'Bitte einen vollständigen, gültigen Auswertungs- und Vergleichszeitraum eingeben.',
        title: 'Finanzauswertung und Abstimmung',
        comparisonFrom: 'Vergleich von',
        comparisonTo: 'Vergleich bis',
        forecastTo: 'Liquiditätsvorschau bis',
        refresh: 'Auswertung aktualisieren',
        aging: 'Altersstruktur offener Posten',
        partners: 'Kunden- und Lieferantensalden',
        cash: 'Tatsächliche Zahlungsströme',
        dimensions: 'Kostenstellen und Kostenträger',
        reconciliation: 'Abstimmung Hauptbuch und Nebenbuch',
        liquidity: 'Liquiditätsvorschau',
        tasks: 'Aufgaben',
        definition: 'Gebuchte Erlöse und Aufwendungen unterscheiden sich von tatsächlichen Geldbewegungen. Offene Posten verwenden datierte Ereignisse zum gewählten Tag einschließlich Partnerguthaben. Die Vorschau berücksichtigt Restrechnungen zur Fälligkeit und die heute hinterlegten Zahlungspläne (auch bei historischem Stichtag) mit belegten Buchwerten. Sie unterstellt Zahlung beziehungsweise Einzug; es wird keine Überweisung gesendet.',
        comparison: 'Vergleichszeitraum',
        current: 'Nicht überfällig',
        days1to30: '1–30 Tage überfällig',
        days31to60: '31–60 Tage überfällig',
        days61to90: '61–90 Tage überfällig',
        over90: 'Über 90 Tage überfällig',
        credits: 'Partnerguthaben',
        inflow: 'Zufluss',
        outflow: 'Abfluss',
        opening: 'Anfangsbestand',
        closing: 'Endbestand',
        ledgerAmount: 'Hauptbuch',
        subledgerAmount: 'Offene Posten',
        difference: 'Differenz',
        receivables: 'Erwartete Eingänge',
        payables: 'Erwartete Ausgänge',
        balance: 'Erwarteter Geldbestand',
        result: 'Ergebnis',
        empty: 'Keine passenden Finanzdaten.',
        export: 'Finanzauswertung exportieren',
        all: 'Alle',
        DRAFTS: 'Nicht festgeschriebene Buchungen',
        OVERDUE_CUSTOMER: 'Überfällige Kundenrechnungen',
        OVERDUE_VENDOR: 'Überfällige Lieferantenrechnungen',
        RECONCILIATION: 'Abstimmdifferenzen',
        beforeStart: 'Wählen Sie einen Zeitraum ab dem Buchhaltungsstart.',
    },
    fr: {
        homeCarrying: 'Valeur comptable en devise de base',
        nameAscending: 'Nom : A–Z',
        nameDescending: 'Nom : Z–A',
        bankReconciliation: 'Relevés et soldes comptables',
        sourceBalance: 'Solde du relevé',
        statementDate: 'Date du relevé',
        MATCHED: 'Rapproché',
        DIFFERENCE: 'Écart à vérifier',
        MISSING_STATEMENT: 'Aucun solde de relevé disponible',
        MISSING_MAPPING: 'Affecter le compte bancaire du grand livre',
        CURRENCY_MISMATCH: 'Devises du compte et du relevé différentes',
        INCOMPLETE_CURRENCY: 'Justificatif en devise d’origine manquant',
        CONFLICTING_STATEMENTS: 'Soldes contradictoires à la même date',
        BEFORE_START: 'Relevé antérieur au début comptable',
        UNMATCHED_BANK: 'Mouvements bancaires non résolus',
        invalidDates: 'Saisissez des périodes d’analyse et de comparaison complètes et valides.',
        title: 'Analyse financière et rapprochement',
        comparisonFrom: 'Comparaison du',
        comparisonTo: 'Comparaison au',
        forecastTo: 'Prévision de trésorerie au',
        refresh: 'Actualiser l’analyse',
        aging: 'Ancienneté des postes ouverts',
        partners: 'Soldes clients et fournisseurs',
        cash: 'Flux de trésorerie réels',
        dimensions: 'Centres de coûts et objets de coûts',
        reconciliation: 'Rapprochement grand livre et auxiliaires',
        liquidity: 'Prévision de trésorerie',
        tasks: 'Tâches',
        definition: 'Les produits et charges comptabilisés diffèrent des mouvements réels. Les postes ouverts utilisent les événements datés au jour choisi, y compris les crédits des partenaires. La prévision utilise les factures restantes à leur échéance et les dates de planification actuelles (même pour un jour historique), aux valeurs comptables justifiées. Elle suppose leur règlement et ne transmet aucun virement.',
        comparison: 'Période comparative',
        current: 'Non échu',
        days1to30: 'Retard de 1 à 30 jours',
        days31to60: 'Retard de 31 à 60 jours',
        days61to90: 'Retard de 61 à 90 jours',
        over90: 'Retard supérieur à 90 jours',
        credits: 'Crédits des partenaires',
        inflow: 'Encaissements',
        outflow: 'Décaissements',
        opening: 'Solde initial',
        closing: 'Solde final',
        ledgerAmount: 'Grand livre',
        subledgerAmount: 'Postes ouverts',
        difference: 'Écart',
        receivables: 'Encaissements prévus',
        payables: 'Paiements prévus',
        balance: 'Trésorerie prévisionnelle',
        result: 'Résultat',
        empty: 'Aucune donnée financière correspondante.',
        export: 'Exporter l’analyse',
        all: 'Tous',
        DRAFTS: 'Écritures non validées',
        OVERDUE_CUSTOMER: 'Factures clients échues',
        OVERDUE_VENDOR: 'Factures fournisseurs échues',
        RECONCILIATION: 'Écarts de rapprochement',
        beforeStart: 'Choisissez une période à partir du début comptable.',
    },
    es: {
        homeCarrying: 'Valor contable en moneda base',
        nameAscending: 'Nombre: A–Z',
        nameDescending: 'Nombre: Z–A',
        bankReconciliation: 'Extractos y saldos contables',
        sourceBalance: 'Saldo del extracto',
        statementDate: 'Fecha del extracto',
        MATCHED: 'Conciliado',
        DIFFERENCE: 'Revisar diferencia',
        MISSING_STATEMENT: 'Sin saldo de extracto disponible',
        MISSING_MAPPING: 'Asignar la cuenta bancaria del mayor',
        CURRENCY_MISMATCH: 'Monedas de cuenta y extracto distintas',
        INCOMPLETE_CURRENCY: 'Falta justificante en moneda original',
        CONFLICTING_STATEMENTS: 'Saldos contradictorios en la misma fecha',
        BEFORE_START: 'Extracto anterior al inicio contable',
        UNMATCHED_BANK: 'Movimientos bancarios sin resolver',
        invalidDates: 'Introduzca períodos completos y válidos para el análisis y la comparación.',
        title: 'Análisis financiero y conciliación',
        comparisonFrom: 'Comparación desde',
        comparisonTo: 'Comparación hasta',
        forecastTo: 'Previsión hasta',
        refresh: 'Actualizar informe',
        aging: 'Antigüedad de partidas abiertas',
        partners: 'Saldos de clientes y proveedores',
        cash: 'Flujos de efectivo reales',
        dimensions: 'Centros y objetos de costes',
        reconciliation: 'Conciliación del mayor y auxiliares',
        liquidity: 'Previsión de liquidez',
        tasks: 'Tareas',
        definition: 'Los ingresos y gastos contabilizados difieren de los movimientos reales. Las partidas abiertas usan eventos fechados al día elegido, incluidos los créditos de socios. La previsión utiliza facturas pendientes a su vencimiento y fechas de planificación actuales (incluso con fecha histórica) con valores contables documentados. Presupone su cobro o pago y no envía transferencias.',
        comparison: 'Período comparativo',
        current: 'No vencido',
        days1to30: 'Vencido 1–30 días',
        days31to60: 'Vencido 31–60 días',
        days61to90: 'Vencido 61–90 días',
        over90: 'Vencido más de 90 días',
        credits: 'Créditos de socios',
        inflow: 'Entradas',
        outflow: 'Salidas',
        opening: 'Saldo inicial',
        closing: 'Saldo final',
        ledgerAmount: 'Mayor',
        subledgerAmount: 'Partidas abiertas',
        difference: 'Diferencia',
        receivables: 'Cobros previstos',
        payables: 'Pagos previstos',
        balance: 'Saldo de efectivo previsto',
        result: 'Resultado',
        empty: 'No hay datos financieros coincidentes.',
        export: 'Exportar análisis',
        all: 'Todos',
        DRAFTS: 'Asientos sin contabilizar',
        OVERDUE_CUSTOMER: 'Facturas de clientes vencidas',
        OVERDUE_VENDOR: 'Facturas de proveedores vencidas',
        RECONCILIATION: 'Diferencias de conciliación',
        beforeStart: 'Seleccione un período a partir del inicio contable.',
    },
    tr: {
        homeCarrying: 'Ana para biriminde defter değeri',
        nameAscending: 'Ad: A–Z',
        nameDescending: 'Ad: Z–A',
        bankReconciliation: 'Banka ekstreleri ve defter bakiyeleri',
        sourceBalance: 'Ekstre bakiyesi',
        statementDate: 'Ekstre tarihi',
        MATCHED: 'Mutabık',
        DIFFERENCE: 'Farkı inceleyin',
        MISSING_STATEMENT: 'Ekstre bakiyesi yok',
        MISSING_MAPPING: 'Uygun banka defter hesabını eşleyin',
        CURRENCY_MISMATCH: 'Hesap ve ekstre para birimi uyuşmuyor',
        INCOMPLETE_CURRENCY: 'Asıl para birimi defter kanıtı eksik',
        CONFLICTING_STATEMENTS: 'Aynı günde çelişen bakiyeler',
        BEFORE_START: 'Ekstre muhasebe başlangıcından önce',
        UNMATCHED_BANK: 'Çözümlenmemiş banka hareketleri',
        invalidDates: 'Geçerli ve eksiksiz rapor ve karşılaştırma dönemleri girin.',
        title: 'Mali analiz ve mutabakat',
        comparisonFrom: 'Karşılaştırma başlangıcı',
        comparisonTo: 'Karşılaştırma sonu',
        forecastTo: 'Likidite tahmini sonu',
        refresh: 'Raporu güncelle',
        aging: 'Açık kalem yaşlandırması',
        partners: 'Müşteri ve tedarikçi bakiyeleri',
        cash: 'Gerçek nakit hareketleri',
        dimensions: 'Maliyet merkezleri ve nesneleri',
        reconciliation: 'Ana defter ve yardımcı defter mutabakatı',
        liquidity: 'Likidite tahmini',
        tasks: 'Görevler',
        definition: 'Muhasebeleşen gelir ve giderler gerçek para hareketlerinden farklıdır. Açık kalemler seçilen gündeki tarihli olayları ve cari alacakları kullanır. Tahmin, kalan faturaları vade ve güncel ödeme planı tarihlerinde (geçmiş rapor günü için de) belgelenmiş defter değerleriyle gösterir. Tahsilat veya ödeme varsayılır; banka havalesi gönderilmez.',
        comparison: 'Karşılaştırma dönemi',
        current: 'Vadesi gelmedi',
        days1to30: '1–30 gün gecikmiş',
        days31to60: '31–60 gün gecikmiş',
        days61to90: '61–90 gün gecikmiş',
        over90: '90 günden fazla gecikmiş',
        credits: 'Cari alacaklar',
        inflow: 'Giriş',
        outflow: 'Çıkış',
        opening: 'Açılış bakiyesi',
        closing: 'Kapanış bakiyesi',
        ledgerAmount: 'Ana defter',
        subledgerAmount: 'Açık kalemler',
        difference: 'Fark',
        receivables: 'Beklenen tahsilatlar',
        payables: 'Beklenen ödemeler',
        balance: 'Beklenen para bakiyesi',
        result: 'Sonuç',
        empty: 'Uygun mali veri yok.',
        export: 'Mali analizi dışa aktar',
        all: 'Tümü',
        DRAFTS: 'Kesinleşmemiş kayıtlar',
        OVERDUE_CUSTOMER: 'Gecikmiş müşteri faturaları',
        OVERDUE_VENDOR: 'Gecikmiş tedarikçi faturaları',
        RECONCILIATION: 'Mutabakat farkları',
        beforeStart: 'Muhasebe başlangıcından sonraki bir dönem seçin.',
    },
};
//# sourceMappingURL=ledger-analysis.js.map